// @flow
import React, { Component } from 'react';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';

type Props = {
  className?: string,
  children: any,
};


class FriendsRowList extends Component {
  props: Props;

  static defaultProps = {
    className: undefined,
  };

  render() {
    const {
      className,
      children,
    } = this.props;
    // this was once an animated group
    // but to be honest, the animation wasn't great - for now
    // i've removed it
    return (
      <div
        className={className}
      >
        {children}
      </div>
    );
  }
}


export default FriendsRowList;
